const ADD_REASON = ["All", "Amount", "Remove Amount"];
const STATUS = ["All", "APPROVED", "PROCESSED","REJECTED"];
const DEPARTMENTAL_CODE = ["All", "SP101", "SP102"];
const USER_WALLET_REQUEST_TYPE = [
  "All",
  "MONEY ADDED TO WALLET",
  "MONEY DEBITED FROM WALLET",
];
const USER_WALLET_TRANSACTION_TYPE = ["All", "WALLET", "SCAN AND PAY"];
const PAYMENT_STATUS_TYPE = ["All", "Success", "Pending"];

export {
  ADD_REASON,
  DEPARTMENTAL_CODE,
  USER_WALLET_REQUEST_TYPE,
  USER_WALLET_TRANSACTION_TYPE,
  PAYMENT_STATUS_TYPE,
  STATUS,
};
